"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Instantiates a blueprint and returns information needed to place the actors
 * and components into the save game.
 * @param blueprint The blueprint that should be instantiated
 * @param transform Position and rotation at which the blueprint should be instantiated
 * @param saveGame SaveGame to look up stuff in the subsystems
 */
function createActorsFromBlueprint(blueprint, transform, saveGame) {
    throw Error('not implemented yet');
}
exports.createActorsFromBlueprint = createActorsFromBlueprint;
